import PropTypes from 'prop-types';
import cx from 'classnames';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';

import ColumnGridBody from './Body';

const View = ({ data, path, metadata, className }) => (
  <div className={cx('block', 'csjColumnGrid', className)}>
    <ColumnGridBody data={data} path={path} metadata={metadata} />
  </div>
);

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  path: PropTypes.string,
  metadata: PropTypes.objectOf(PropTypes.any),
  className: PropTypes.string,
};

export default withBlockExtensions(View);
